module.exports = __webpack_public_path__ + "img/card.d5cbd1e2.svg";